import React from 'react';
import { Text } from '@perch-labs/shrike';
import { Accordion } from 'components/accordion';
import { MAX_SECONDARY_PAGE_WIDTH } from 'domain/style';
import { Container } from 'styles';
import { copyFor } from 'config';
import { AccordionWrapper } from './different-username-accordion.style';

const getCopy = copyFor('settings.differentUsernameAccordion');

export const DifferentUsernameAccordion = () => {
  return (
    <AccordionWrapper>
      <Container maxWidth={MAX_SECONDARY_PAGE_WIDTH} margin="auto">
        <Accordion label={getCopy('label')}>
          {getCopy('content').map((copy: string, index: number) => (
            <Text
              textStyle="paragraph400"
              key={copy}
              margin={index === 0 ? { bottom: '16px' } : undefined}
            >
              {copy}
            </Text>
          ))}
        </Accordion>
      </Container>
    </AccordionWrapper>
  );
};
